/**
 * Arrival station picked server-side by the airline transfer hub search (`typeSpecific.details.destination`).
 * Returns null outside the airline flow; the page then falls back to the estimation's destination.
 */
export const getAirlineDeutscheBahnArrivalStation = (locationState: any): any | null => {
  if (locationState?.meta?.source !== "airline") {
    return null;
  }

  return locationState?.typeSpecific?.details?.destination || null;
};
